import Vue from 'vue'
import { router } from '@src/routes'
import { scrollToRouteHash } from '@shared/utils/scroll'

export function beforeRouteEnter(to, from, next) {
  if (window.content) {
    next(async vm => {
      vm.template = window.content
      window.content = undefined

      await scrollToRouteHash(to.hash)
    })
  } else {
    const path = to.path.replace(router.history.base, '')
    Vue.http.get(`templates${path}`, { params: to.query }).then(
      data => {
        next(async vm => {
          vm.template = data.data

          await scrollToRouteHash(to.hash)
        })
      },
      data => {
        if (data.status === 403) {
          next({ name: 'E403' })
        } else {
          next({ name: 'E404' })
        }
      }
    )
  }
}

export function beforeRouteUpdate(to, from, next) {
  const path = to.path.replace(router.history.base, '')
  Vue.http.get(`templates${path}`, { params: to.query }).then(
    async data => {
      this.template = data.data

      await scrollToRouteHash(to.hash)

      next()
    },
    data => {
      if (data.status === 403) {
        next({ name: 'E403' })
      } else {
        next({ name: 'E404' })
      }
    }
  )
}

export default { beforeRouteUpdate, beforeRouteEnter }



// WEBPACK FOOTER //
// ./src/assets/js/routerPageHook.js